export const GET_PROJECT_ALL_BRANDS_RESPONSE = 'get-project-all-brands-response';
export const GET_PROJECT_DAILY_STATS = 'get-project-daily-stats';
export const GET_PROJECT_VISIBILITY_CHART = 'get-project-visibility-chart';
export const GET_PROJECT_VISIBILITY_CHART_PER_BRAND = 'get-project-visibility-chart-per-brand';
export const GET_PROJECT_SOV_TIME_SERIES = 'get-project-sov-time-series';
export const GET_PROJECT_MODEL_DATA_DATE_RANGES = 'get-project-model-data-date-ranges';
export const GET_PROJECT_VISIBILITY_PER_MONITOR = 'get-project-visibility-per-monitor';
export const GET_PROJECT_SOV_PER_MODEL = 'get-project-sov-per-model';
export const GET_PROJECT_LIVE_BRAND_KEYS = 'get-project-live-brand-keys';
export const GET_PROJECTS_LIST_KPIS = 'get-projects-list-kpis';
